import React, { useState } from "react";
import { Grid, Button } from "@mui/material";
import SearchInput from "../../../../components/SearchInput";

interface ISearchHeaderProps {
  placeholder: string;
  onSearch: (_query: string) => void;
  onClear: () => void;
  buttonLabel?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
}

/**
 * Reusable search header component with optional action button
 */
const SearchHeader: React.FC<ISearchHeaderProps> = ({
  placeholder,
  onSearch,
  onClear,
  buttonLabel,
  onButtonClick,
  showButton = true,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [isSearchActive, setIsSearchActive] = useState(false);

  const handleSubmit = (isClear?: boolean) => {
    setIsSearchActive(true);
    if (searchValue && !isClear) {
      onSearch(searchValue);
    } else {
      onClear();
    }
  };

  const handleClose = () => {
    setSearchValue("");
    onClear();
    setIsSearchActive(false);
  };

  return (
    <Grid container alignItems="center" className="m-t-20" spacing={2}>
      <Grid item xs={12} md={6} lg={3.8}>
        <SearchInput
          searchValue={searchValue}
          placeholder={placeholder}
          handleSubmit={handleSubmit}
          handleChange={(value: string) => setSearchValue(value)}
          handleClose={handleClose}
          activeSearch={isSearchActive}
        />
      </Grid>

      {showButton && buttonLabel && onButtonClick && (
        <Grid item xs={12} md={4} lg={2}>
          <Button
            className="w-100"
            variant="contained"
            onClick={onButtonClick}
          >
            {buttonLabel}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default SearchHeader;
